module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"ordersOverview":"Oppdrag | Oppdrag ({n}) | Oppdrag ({n})","originalMessage":"JSON"},"en":{"ordersOverview":"Orders| Orders({n}) | Orders({n})","originalMessage":"JSON"}}')
  delete Component.options._Ctor
}
